var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 59,
    viewBox: "0 0 239 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.5649 24.9431L72.5176 14.882H67.0872L67.8125 11.1068H83.5457L82.8204 14.882H77.3901L75.4373 24.9431H70.5649ZM90.1393 14.603L89.6744 17.0207H94.7701C96.2206 17.0207 96.5182 16.2582 96.5182 15.6817C96.5182 15.0866 96.2392 14.603 95.0676 14.603H90.1393ZM98.0618 18.2853C99.438 18.6386 100.982 19.5313 100.442 22.2651L100.163 23.7157C100.014 24.4038 100.126 24.6642 100.219 24.8501L100.2 24.9431H95.142C95.0862 24.8501 95.0304 24.6084 95.1234 24.0876L95.3466 22.8974C95.6999 21.1121 95.049 20.5914 93.1149 20.5914H88.9677L88.1308 24.9431H83.2212L85.9178 11.1068H96.481C100.814 11.1068 101.8 13.0223 101.8 14.6588C101.8 17.1137 99.6983 18.0621 98.0618 18.2853ZM111.548 25.1477C103.867 25.1477 103.29 20.3868 103.811 17.7088L105.113 11.1068H109.986L108.721 17.6716C108.405 19.271 108.851 21.1307 111.92 21.1307H111.994C114.97 21.1307 115.602 19.2524 115.899 17.6716L117.183 11.1068H122.055L120.791 17.7088C120.27 20.4426 119.321 25.1477 112.087 25.1477H111.548ZM125.074 11.1068H138.594L137.943 14.3985H129.332L128.979 16.2396H137.329L136.66 19.6243H128.31L127.938 21.6142H136.678L136.027 24.9431H122.377L125.074 11.1068Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5649 24.9431L72.5176 14.882H67.0872L67.8125 11.1068H83.5457L82.8204 14.882H77.3901L75.4373 24.9431H70.5649ZM90.1393 14.603L89.6744 17.0207H94.7701C96.2206 17.0207 96.5182 16.2582 96.5182 15.6817C96.5182 15.0866 96.2392 14.603 95.0676 14.603H90.1393ZM98.0618 18.2853C99.438 18.6386 100.982 19.5313 100.442 22.2651L100.163 23.7157C100.014 24.4038 100.126 24.6642 100.219 24.8501L100.2 24.9431H95.142C95.0862 24.8501 95.0304 24.6084 95.1234 24.0876L95.3466 22.8974C95.6999 21.1121 95.049 20.5914 93.1149 20.5914H88.9677L88.1308 24.9431H83.2212L85.9178 11.1068H96.481C100.814 11.1068 101.8 13.0223 101.8 14.6588C101.8 17.1137 99.6983 18.0621 98.0618 18.2853ZM111.548 25.1477C103.867 25.1477 103.29 20.3868 103.811 17.7088L105.113 11.1068H109.986L108.721 17.6716C108.405 19.271 108.851 21.1307 111.92 21.1307H111.994C114.97 21.1307 115.602 19.2524 115.899 17.6716L117.183 11.1068H122.055L120.791 17.7088C120.27 20.4426 119.321 25.1477 112.087 25.1477H111.548ZM125.074 11.1068H138.594L137.943 14.3985H129.332L128.979 16.2396H137.329L136.66 19.6243H128.31L127.938 21.6142H136.678L136.027 24.9431H122.377L125.074 11.1068Z",
    fill: "url(#paint0_linear_4419_29)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.693 31.1834C84.2435 31.1834 85.2106 34.4565 84.913 37.0229H79.8174C79.7988 36.5208 79.65 34.8843 76.2839 34.8843C72.862 34.8843 72.0437 37.1345 72.0437 38.7897C72.0437 40.2031 72.769 41.7094 75.4842 41.7094C78.7015 41.7094 79.2409 39.9055 79.3153 39.5894H84.4295C84.1319 41.6908 82.9975 45.4661 75.8934 45.4661H75.0751C68.3615 45.4661 66.8737 42.0628 66.8737 38.9199C66.8737 35.8885 68.6032 31.1834 75.8748 31.1834H76.693ZM95.6028 31.1648H96.4211C103.302 31.1648 104.753 34.7169 104.753 37.5623C104.753 40.8726 103.023 45.4847 95.6028 45.4847H94.7845C87.9221 45.4847 86.453 41.821 86.453 38.957C86.453 35.7769 88.1639 31.1648 95.6028 31.1648ZM99.657 37.6924C99.657 36.4092 99.0061 34.8843 96.012 34.8843C92.1809 34.8843 91.5672 37.4135 91.5672 38.8455C91.5672 40.1101 92.2181 41.7094 95.2123 41.7094C99.3409 41.7094 99.657 38.8269 99.657 37.6924ZM105.832 45.2429L108.529 31.4066H114.945L117.102 39.3476L122.309 31.4066H129.079L126.401 45.2429H121.603L123.295 36.558L117.586 45.2429H114.499L112.174 36.558L110.482 45.2429H105.832ZM129.478 45.2429L132.175 31.4066H138.591L140.748 39.3476L145.956 31.4066H152.725L150.047 45.2429H145.249L146.941 36.558L141.232 45.2429H138.145L135.82 36.558L134.128 45.2429H129.478ZM162.2 45.4475C154.519 45.4475 153.943 40.6866 154.464 38.0086L155.765 31.4066H160.638L159.373 37.9714C159.057 39.5708 159.503 41.4305 162.572 41.4305H162.646C165.622 41.4305 166.254 39.5522 166.552 37.9714L167.835 31.4066H172.707L171.443 38.0086C170.922 40.7424 169.974 45.4475 162.739 45.4475H162.2ZM185.397 45.2429L179.427 36.9671L177.828 45.2429H173.029L175.726 31.4066H180.729L186.457 39.4406L188.019 31.4066H192.798L190.102 45.2429H185.397ZM200.74 31.4066L198.062 45.2429H193.152L195.849 31.4066H200.74ZM205.849 45.2429L207.802 35.1818H202.372L203.097 31.4066H218.83L218.105 35.1818H212.674L210.722 45.2429H205.849ZM223.769 45.2429L224.717 40.2961L219.38 31.4066H224.959L227.748 36.3162L232.472 31.4066H238.163L229.608 40.3146L228.641 45.2429H223.769Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.693 31.1834C84.2435 31.1834 85.2106 34.4565 84.913 37.0229H79.8174C79.7988 36.5208 79.65 34.8843 76.2839 34.8843C72.862 34.8843 72.0437 37.1345 72.0437 38.7897C72.0437 40.2031 72.769 41.7094 75.4842 41.7094C78.7015 41.7094 79.2409 39.9055 79.3153 39.5894H84.4295C84.1319 41.6908 82.9975 45.4661 75.8934 45.4661H75.0751C68.3615 45.4661 66.8737 42.0628 66.8737 38.9199C66.8737 35.8885 68.6032 31.1834 75.8748 31.1834H76.693ZM95.6028 31.1648H96.4211C103.302 31.1648 104.753 34.7169 104.753 37.5623C104.753 40.8726 103.023 45.4847 95.6028 45.4847H94.7845C87.9221 45.4847 86.453 41.821 86.453 38.957C86.453 35.7769 88.1639 31.1648 95.6028 31.1648ZM99.657 37.6924C99.657 36.4092 99.0061 34.8843 96.012 34.8843C92.1809 34.8843 91.5672 37.4135 91.5672 38.8455C91.5672 40.1101 92.2181 41.7094 95.2123 41.7094C99.3409 41.7094 99.657 38.8269 99.657 37.6924ZM105.832 45.2429L108.529 31.4066H114.945L117.102 39.3476L122.309 31.4066H129.079L126.401 45.2429H121.603L123.295 36.558L117.586 45.2429H114.499L112.174 36.558L110.482 45.2429H105.832ZM129.478 45.2429L132.175 31.4066H138.591L140.748 39.3476L145.956 31.4066H152.725L150.047 45.2429H145.249L146.941 36.558L141.232 45.2429H138.145L135.82 36.558L134.128 45.2429H129.478ZM162.2 45.4475C154.519 45.4475 153.943 40.6866 154.464 38.0086L155.765 31.4066H160.638L159.373 37.9714C159.057 39.5708 159.503 41.4305 162.572 41.4305H162.646C165.622 41.4305 166.254 39.5522 166.552 37.9714L167.835 31.4066H172.707L171.443 38.0086C170.922 40.7424 169.974 45.4475 162.739 45.4475H162.2ZM185.397 45.2429L179.427 36.9671L177.828 45.2429H173.029L175.726 31.4066H180.729L186.457 39.4406L188.019 31.4066H192.798L190.102 45.2429H185.397ZM200.74 31.4066L198.062 45.2429H193.152L195.849 31.4066H200.74ZM205.849 45.2429L207.802 35.1818H202.372L203.097 31.4066H218.83L218.105 35.1818H212.674L210.722 45.2429H205.849ZM223.769 45.2429L224.717 40.2961L219.38 31.4066H224.959L227.748 36.3162L232.472 31.4066H238.163L229.608 40.3146L228.641 45.2429H223.769Z",
    fill: "url(#paint1_linear_4419_29)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9618 53.6346L32.3052 57.3024C46.5157 55.5552 57.5188 43.4423 57.5188 28.7594C57.5188 24.5529 56.6157 20.5572 54.9928 16.9559L52.8096 20.5424C53.69 23.1198 54.1677 25.8838 54.1677 28.7594C54.1677 41.009 45.4991 51.234 33.9618 53.6346ZM12.472 9.2573C16.8821 5.57027 22.5616 3.35115 28.7594 3.35115C34.9572 3.35115 40.6368 5.57027 45.0468 9.2573H49.8966C44.642 3.56501 37.117 0 28.7594 0C20.4018 0 12.8768 3.56501 7.62225 9.2573H12.472ZM4.62815 20.7837L2.41123 17.2141C0.860581 20.7479 0 24.6531 0 28.7594C0 43.3519 10.8681 55.406 24.9516 57.269L23.2837 53.5762C11.8831 51.0721 3.35115 40.9121 3.35115 28.7594C3.35115 25.9734 3.79956 23.2921 4.62815 20.7837Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9618 53.6346L32.3052 57.3024C46.5157 55.5552 57.5188 43.4423 57.5188 28.7594C57.5188 24.5529 56.6157 20.5572 54.9928 16.9559L52.8096 20.5424C53.69 23.1198 54.1677 25.8838 54.1677 28.7594C54.1677 41.009 45.4991 51.234 33.9618 53.6346ZM12.472 9.2573C16.8821 5.57027 22.5616 3.35115 28.7594 3.35115C34.9572 3.35115 40.6368 5.57027 45.0468 9.2573H49.8966C44.642 3.56501 37.117 0 28.7594 0C20.4018 0 12.8768 3.56501 7.62225 9.2573H12.472ZM4.62815 20.7837L2.41123 17.2141C0.860581 20.7479 0 24.6531 0 28.7594C0 43.3519 10.8681 55.406 24.9516 57.269L23.2837 53.5762C11.8831 51.0721 3.35115 40.9121 3.35115 28.7594C3.35115 25.9734 3.79956 23.2921 4.62815 20.7837Z",
    fill: "url(#paint2_linear_4419_29)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10938 19.6255H51.1617L48.0759 25.1799H9.19515L6.10938 19.6255Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10938 19.6255H51.1617L48.0759 25.1799H9.19515L6.10938 19.6255Z",
    fill: "url(#paint3_linear_4419_29)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19515 25.1799H15.4038L24.7475 41.4728V52.273L9.19515 25.1799Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19515 25.1799H15.4038L24.7475 41.4728V52.273L9.19515 25.1799Z",
    fill: "url(#paint4_linear_4419_29)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8672 25.1799H48.0759L45.0292 30.4874H38.8235L41.8672 25.1799Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8672 25.1799H48.0759L45.0292 30.4874H38.8235L41.8672 25.1799Z",
    fill: "url(#paint5_linear_4419_29)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1427 36.9058L32.5236 41.4728V52.273L41.3448 36.9058H35.1427Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1427 36.9058L32.5236 41.4728V52.273L41.3448 36.9058H35.1427Z",
    fill: "url(#paint6_linear_4419_29)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2959 11.479H55.8524L52.7666 17.0334H4.38167L1.2959 11.479Z",
    fill: "#D9D9D9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2959 11.479H55.8524L52.7666 17.0334H4.38167L1.2959 11.479Z",
    fill: "url(#paint7_linear_4419_29)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7352 17.0334H31.6599V18.638H25.7352V17.0334Z",
    fill: "#D9D9D9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7352 17.0334H31.6599V18.638H25.7352V17.0334Z",
    fill: "url(#paint8_linear_4419_29)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7354 26.1675H31.66V54.3097L28.6977 59.0001L25.7354 54.3097V26.1675Z",
    fill: "#D9D9D9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7354 26.1675H31.66V54.3097L28.6977 59.0001L25.7354 54.3097V26.1675Z",
    fill: "url(#paint9_linear_4419_29)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4419_29",
    x1: 135.42,
    y1: 23.9735,
    x2: 68.3115,
    y2: 14.3134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4419_29",
    x1: 65.2002,
    y1: 39.7429,
    x2: 236.2,
    y2: 39.7429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A24604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#FF6C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A14604"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4419_29",
    x1: -2.14274e-7,
    y1: 28.6512,
    x2: 57.5188,
    y2: 28.6512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A24604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#FF6C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A14604"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4419_29",
    x1: 51.1617,
    y1: 32.4152,
    x2: 6.09293,
    y2: 32.2523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4419_29",
    x1: 51.1617,
    y1: 32.4152,
    x2: 6.09293,
    y2: 32.2523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4419_29",
    x1: 51.1617,
    y1: 32.4152,
    x2: 6.09293,
    y2: 32.2523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4419_29",
    x1: 51.1617,
    y1: 32.4152,
    x2: 6.09293,
    y2: 32.2523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4419_29",
    x1: 1.2959,
    y1: 15.0585,
    x2: 55.8524,
    y2: 15.0585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A24604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#FF6C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A14604"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4419_29",
    x1: 1.2959,
    y1: 15.0585,
    x2: 55.8524,
    y2: 15.0585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A24604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#FF6C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A14604"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4419_29",
    x1: 17.1074,
    y1: 22.4256,
    x2: 35.4178,
    y2: 61.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A24604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#FF6C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A14604"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a649910b02ddf5fbcf5d224a8aa74cd9.svg";
export { ForwardRef as ReactComponent };